var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevronRightDouble = function SvgChevronRightDouble(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10.056 12 4.47 6.4l1.054-1.054L12.179 12l-6.654 6.654L4.47 17.6zm7.35 0L11.82 6.4l1.054-1.054L19.529 12l-6.654 6.654L11.82 17.6z"
  })));
};
export default SvgChevronRightDouble;